module.exports = __webpack_public_path__ + "images/39dbd26e684f348990a2d8a3fd48da08.png";